module.exports = __webpack_public_path__ + "img/vip-banner-bg.2385f273.png";